import { keepPreviousData } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { useGetV4AdvReportTotals } from "./v4AdvReportTotals";

type Params = {
  adId: string | number;
  filters?: ColumnFiltersState;
  search?: string;
};

type Options = {
  enabled?: boolean;
};

export const useAdTotals = ({ adId, filters = [], search }: Params, { enabled = true }: Options = {}) => {
  const totalsOptionsGetter = useGetV4AdvReportTotals();
  const numericAdId = Number(adId);

  return {
    ...totalsOptionsGetter({
      filters: [
        {
          id: "ad_id",
          value: { op: "=", value: numericAdId },
        },
        ...filters,
      ],
      search,
    }),
    enabled,
    placeholderData: keepPreviousData,
  };
};
